export const NAME = 'COUNTRIES';

export const countries = (store) => store[NAME].list?.data || [];
export const countryOptions = (store) => store[NAME].optionsList?.data || [];
